import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ColorEntry } from '../models/drilling.models';

export type TimeScale = 'week' | 'month';

@Component({
  selector: 'drill-chart-controls',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './drill-chart-controls.component.html',
  styleUrls: ['./drill-chart-controls.component.scss'],
  imports: [MatButtonToggleModule],
})
export class DrillChartControlsComponent {
  readonly colorBy   = input<'rig' | 'operator'>('rig');
  readonly timeScale = input<TimeScale>('week');
  readonly palette   = input<ColorEntry[]>([]);

  readonly colorByChange    = output<'rig' | 'operator'>();
  readonly timeScaleChange  = output<TimeScale>();
  /** Emitted with -1 (back) or +1 (forward) when the nav arrows are clicked. */
  readonly navigate         = output<-1 | 1>();
}
